import React, { useState } from "react";
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { api } from "../../services/api";

/* Baja de un evento. Pide escribir el nombre exacto porque es una acción que el
 * usuario no puede deshacer desde la aplicación. */
const EliminarEventoDialog = ({ abierto, onClose, eventoId, nombreEvento, onEliminado }) => {
  const [t] = useTranslation("global");
  const [nombreIngresado, setNombreIngresado] = useState("");
  const [eliminando, setEliminando] = useState(false);

  const nombreCoincide = nombreIngresado.trim() === (nombreEvento ?? "").trim();

  const cerrar = () => {
    setNombreIngresado("");
    onClose();
  };

  const eliminar = async () => {
    setEliminando(true);
    try {
      const response = await api.eventos.deleteEvento(eventoId);
      if (response.status !== "success") {
        // el backend explica por qué no se puede (tickets, vouchers, publicaciones)
        toast.error(response.message || t("event.deleteValidationError"), {
          autoClose: 8000,
        });
        return;
      }

      toast.success("El evento se eliminó correctamente.");
      onEliminado();
    } catch (error) {
      console.error("Error al eliminar el evento:", error);
      toast.error("No se pudo conectar con el servidor.");
    } finally {
      setEliminando(false);
    }
  };

  return (
    <Dialog open={abierto} onClose={cerrar} fullWidth maxWidth="sm">
      <DialogTitle>{t("event.deleteEvent")}</DialogTitle>
      <DialogContent>
        <Alert severity="warning" sx={{ mb: 2 }}>
          Esta acción no se puede deshacer.
        </Alert>
        <p style={{ userSelect: "none" }}>
          {t("event.deleteEvent-p1")} "<b>{nombreEvento}</b>" {t("event.deleteEvent-p2")}
        </p>
        <TextField
          autoFocus
          fullWidth
          size="small"
          value={nombreIngresado}
          onChange={(e) => setNombreIngresado(e.target.value)}
          placeholder={nombreEvento}
          sx={{ mt: 1 }}
        />
        {nombreIngresado && !nombreCoincide && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {t("event.deleteError")}
          </Alert>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={cerrar}>Cancelar</Button>
        <Button
          color="error"
          variant="contained"
          disabled={!nombreCoincide || eliminando}
          onClick={eliminar}
        >
          {eliminando ? "Eliminando..." : t("event.deleteEvent")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EliminarEventoDialog;
